'use strict'

// utility class
import ApplyClass from '../Utils/ApplyClass'
import Common from '../Utils/Common'
import Basic from '../Controller/Basic'

import SmoothScroll from '../View/Basic/SmoothScroll'
import Dropdown from '../View/Basic/Dropdown'
import Collapsed from '../View/Basic/Collapsed'
import Accordion from '../View/Basic/Accordion'
import Toggle from '../View/Basic/Toggle'
import Pagination from '../View/Basic/Pagination'
import Popup from '../View/Basic/Popup'
import Focus from '../View/Basic/Focus'
import { facilityFadeIn, facilitySectionResize } from '../Custom/facility'
import ScrollHint from 'scroll-hint'
import { scrollSidebarAddClass } from '../Custom/sidebar'
import ToggleCustom from '../View/Basic/ToggleCustom'
import { GoogleMap } from '../View/Basic/GoogleMap'
import MicroModal from 'micromodal'
import { MenuAddExternalClass } from '../Custom/menuAddExternalClass'
import Modal from '../View/Basic/Modal'
import Sticky from '../View/Basic/Sticky'
import Languages from '../View/Basic/Languages'
import BtnFavorite from '../View/Basic/BtnFavorite';
import Search from '../View/Basic/Search';
import ModalSelect from '../View/Basic/ModalSelect';
import ModalSelect2 from '../View/Basic/ModalSelect2';
import ModalSelect3 from '../View/Basic/ModalSelect3';
import CountHitNum from '../View/Basic/CountHitNum';
import DeleteSearchTag from '../View/Basic/DeleteSearchTag';
import SearchSort from '../View/Basic/SearchSort';
import ClearSearchCondition from '../View/Basic/ClearSearchCondition'
import BtnSaveFiltering from '../View/Basic/BtnSaveFiltering';
import BtnDeleteFiltering from '../View/Basic/BtnDeleteFiltering';
import BtnAlertClose from '../View/Basic/BtnAlertClose';
import BtnDeleteDocument from '../View/Basic/BtnDeleteDocument';
import TabSelect from '../View/Basic/TabSelect';
import SelectOptionColor from '../View/Basic/SelectOptionColor';
import ColumnTocCreate from '../View/Basic/ColumnTocCreate';
import MailerSettings from '../View/Basic/MailerSettings';
import LineSettings from '../View/Basic/LineSettings';
import MypageBtnMargin from '../View/Basic/MypageBtnMargin';
import TopAnimate from '../View/Basic/TopAnimate';
import Preview from '../View/Basic/Preview'
import JobDetail from '../View/Basic/JobDetail';
import CurrentViewedItem from '../View/Basic/CurrentViewedJob';
import Slider from '../View/Basic/Slider';
import BeginnerTabSelect from '../View/Basic/BeginnerTabSelect';
import TextAreaOpen from '../View/Basic/TextAreaOpen';
import AnchorLinkDtOpen from '../View/Basic/AnchorLinkDtOpen';
import MymenuOpen from '../View/Basic/MymenuOpen';
import EntryFilter from '../View/basic/EntryFilter';
import MypageModal from '../View/Basic/MypageModal';
import ShowTelReserveModal from '../View/Basic/ShowTelReserveModal';
import ShowRequestExplanationModal from "../View/Basic/ShowRequestExplanationModal";



$(() => {
	const BasicController = new Basic()
	// デバイス、ブラウザ判定
	Common.addHtmlClass()
	//objectFitImages();
	//スムーススクロール
	$('a[href^="#"]').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(SmoothScroll, $e, [$e, BasicController])
	})
	// ページネーション
	$('.block--pagination .anchor--page').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(Pagination, $e, [$e, BasicController])
	})
	// ページネーション
	$('.page-link').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(Pagination, $e, [$e, BasicController])
	})
	// Dropdown
	$('.dropdown-link').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(Dropdown, $e, [$e, BasicController])
	})
	// Collapsed
	$('.collapsed').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(Collapsed, $e, [$e, BasicController])
	})
	// Toggle
	$('.toggle-trigger').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(Toggle, $e, [$e, BasicController])
	})
	// Accordion
	$('.dl--accordion dt .btn--open').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(Accordion, $e, [$e, BasicController])
	})
	// popup
	$('.btn--popup').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(Popup, $e, [$e, BasicController])
	})
	// Focus
	$('.pageFaq').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(Focus, $e, [$e, BasicController])
	})
	//Modal
	$('[data-toggle="modal"]').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(Modal, $e, [$e, BasicController])
	})
	//Sticky
	$('.sticky').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(Sticky, $e, [$e, BasicController])
	})
	//Languages
	$('.wovn-languages').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(Languages, $e, [$e, BasicController])
	})
	// 気になるボタン
	$('.icon--favorite').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnFavorite, $e, [$e, BasicController]);
	})
	// 検索ボタン
	$('.btn--search').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Search, $e, [$e, BasicController]);
	});
	// モーダルで検索条件が押された時に呼び出し元のボタンをアクティブにする
	$('.modal--detail-select .input-checkbox-btn').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ModalSelect, $e, [$e, BasicController]);
	});
	// 検索モーダルが立ち上がるときに、「全て」をアクティブにする
	$('main .input-checkbox-btn input[data-target]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ModalSelect2, $e, [$e, BasicController]);
	});
	// 都道府県、おすすめスポットが選択された時に、該当しないものは非活性にする
	$('.modal--detail-select .input-checkbox-btn input').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ModalSelect3, $e, [$e, BasicController]);
	});
	// 該当する求人数の取得
	$('body.detail-search [data-search-type="checkbox"], body.detail-search [type="search"], body.detail-search .btn--clear, body.detail-search .btn--clear-all').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CountHitNum, $e, [$e, BasicController]);
	});
	// 検索条件タグを追加
	$('.btn--tag-del').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(DeleteSearchTag, $e, [$e, BasicController]);
	});
	// ソート
	$('[data-sort]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SearchSort, $e, [$e, BasicController]);
	});
	// 検索条件クリア(求人一覧)
	$('.section--jobList .btn--clear, .section--jobList .btn--clear-all').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(ClearSearchCondition, $e, [$e, BasicController])
	})
	// 保存された検索条件を保存する
	$('.btn--save-filtering').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnSaveFiltering, $e, [$e, BasicController]);
	});
	// 保存された検索条件を削除する
	$('.btn--delete-filtering').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnDeleteFiltering, $e, [$e, BasicController]);
	});
	// アラートの閉じるボタン
	$('.btn--alert-close').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnAlertClose, $e, [$e, BasicController]);
	});
	// 書類の削除
	$('.btn--delete-document').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BtnDeleteDocument, $e, [$e, BasicController]);
	});
	// 求人詳細のタグの切り替え
	$('.tab--job-detail .anchor').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(TabSelect, $e, [$e, BasicController]);
	});
	// 選択リストで「選択してください」の色を変える
	$('select').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SelectOptionColor, $e, [$e, BasicController]);
	});
	// コラムの目次作成
	$('.section.column .board').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ColumnTocCreate, $e, [$e, BasicController]);
	});
	// メールのデフォルト設定
	$('.btn--entry-mail').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(MailerSettings, $e, [$e, BasicController]);
	});
	// メールのデフォルト設定
	$('.btn--entry-line').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(LineSettings, $e, [$e, BasicController]);
	});
	// マイページのボタンの左右の余白
	$('.list--btn-section').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(MypageBtnMargin, $e, [$e, BasicController]);
	});
	// topページのアニメーション
	$('.animete').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(TopAnimate, $e, [$e, BasicController]);
	});
	// プレビュー時は、ボタン等を無効にする
	$('html.preview').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(Preview, $e, [$e, BasicController])
	})
	// 求人詳細
	$('body.job-detail').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(JobDetail, $e, [$e, BasicController]);
	});
	// 最近見た商品
	$('.swiper-viewed-jobs').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CurrentViewedItem, $e, [$e, BasicController]);
	});
	// スライダー
	$('.slider').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Slider, $e, [$e, BasicController]);
	});
	// LP初めての方へのタブ選択
	$('.block--beginner-tab .list-item .tab').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(BeginnerTabSelect, $e, [$e, BasicController]);
	});
	// LP初めての方へのテキストエリアを広げるボタン
	$('.btn--text-area-open').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(TextAreaOpen, $e, [$e, BasicController]);
	});
	// マイメニューの下層メニューをオープンする
	$('.block--mymenu-open').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(MymenuOpen, $e, [$e, BasicController]);
	});
	// アンカーリンクの遷移先がdtであれば、オープンする
	$('.anchor--dt-open').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(AnchorLinkDtOpen, $e, [$e, BasicController]);
	});
	// 求人票のフィルター
	$('.entry-filter').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(EntryFilter, $e, [$e, BasicController]);
	});
	// 福利厚生の非表示
	$('#input_employment_status').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(HideWelfare, $e, [$e, BasicController]);
	});
	// 電話予約のモーダルを表示する
	$('.btn--reserve-tel').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ShowTelReserveModal, $e, [$e, BasicController]);
	});
	// 電話予約のモーダルを表示する
	$('.btn--request-explanation').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ShowRequestExplanationModal, $e, [$e, BasicController]);
	});



	MicroModal.init({ disableScroll: true })
	new GoogleMap()
	new scrollSidebarAddClass()
	new MenuAddExternalClass()
	new ToggleCustom($('.btn--map__accordion'), $('.list--map__accordion'))
	new MypageModal()
	$(window).on('scroll', function () {
		facilityFadeIn($(this))
	})
	$(window).on('resize', function () {
		facilitySectionResize()
	})
	$('.hamburger').on('click', function () {
		$(this).toggleClass('open')
		$('.list--hamburger__menus').toggleClass('open')
	})
	$('.hamburger__accordion__btn').on('click', function () {
		$(this).toggleClass('open')
	})
	$('.accordion__btn').on('click', function () {
		$(this).toggleClass('open')
	})

	facilitySectionResize()

	new ScrollHint('.js-scrollable', {
		i18n: {
			scrollable: 'スクロールできます',
		},
	})
})

//object-fit polyfill
/*! npm.im/object-fit-images 3.2.4 */
var objectFitImages = (function () {
	'use strict'

	var OFI = 'bfred-it:object-fit-images'
	var propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g
	var testImg = typeof Image === 'undefined' ? { style: { 'object-position': 1 } } : new Image()
	var supportsObjectFit = 'object-fit' in testImg.style
	var supportsObjectPosition = 'object-position' in testImg.style
	var supportsOFI = 'background-size' in testImg.style
	var supportsCurrentSrc = typeof testImg.currentSrc === 'string'
	var nativeGetAttribute = testImg.getAttribute
	var nativeSetAttribute = testImg.setAttribute
	var autoModeEnabled = false

	function createPlaceholder(w, h) {
		return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E"
	}

	function polyfillCurrentSrc(el) {
		if (el.srcset && !supportsCurrentSrc && window.picturefill) {
			var pf = window.picturefill._
			// parse srcset with picturefill where currentSrc isn't available
			if (!el[pf.ns] || !el[pf.ns].evaled) {
				// force synchronous srcset parsing
				pf.fillImg(el, { reselect: true })
			}

			if (!el[pf.ns].curSrc) {
				// force picturefill to parse srcset
				el[pf.ns].supported = false
				pf.fillImg(el, { reselect: true })
			}

			// retrieve parsed currentSrc, if any
			el.currentSrc = el[pf.ns].curSrc || el.src
		}
	}

	function getStyle(el) {
		var style = getComputedStyle(el).fontFamily
		var parsed
		var props = {}
		while ((parsed = propRegex.exec(style)) !== null) {
			props[parsed[1]] = parsed[2]
		}
		return props
	}

	function setPlaceholder(img, width, height) {
		// Default: fill width, no height
		var placeholder = createPlaceholder(width || 1, height || 0)

		// Only set placeholder if it's different
		if (nativeGetAttribute.call(img, 'src') !== placeholder) {
			nativeSetAttribute.call(img, 'src', placeholder)
		}
	}

	function onImageReady(img, callback) {
		// naturalWidth is only available when the image headers are loaded,
		// this loop will poll it every 100ms.
		if (img.naturalWidth) {
			callback(img)
		} else {
			setTimeout(onImageReady, 100, img, callback)
		}
	}

	function fixOne(el) {
		var style = getStyle(el)
		var ofi = el[OFI]
		style['object-fit'] = style['object-fit'] || 'fill' // default value

		// Avoid running where unnecessary, unless OFI had already done its deed
		if (!ofi.img) {
			// fill is the default behavior so no action is necessary
			if (style['object-fit'] === 'fill') {
				return
			}

			// Where object-fit is supported and object-position isn't (Safari < 10)
			if (
				!ofi.skipTest && // unless user wants to apply regardless of browser support
				supportsObjectFit && // if browser already supports object-fit
				!style['object-position'] // unless object-position is used
			) {
				return
			}
		}

		// keep a clone in memory while resetting the original to a blank
		if (!ofi.img) {
			ofi.img = new Image(el.width, el.height)
			ofi.img.srcset = nativeGetAttribute.call(el, 'data-ofi-srcset') || el.srcset
			ofi.img.src = nativeGetAttribute.call(el, 'data-ofi-src') || el.src

			// preserve for any future cloneNode calls
			// https://github.com/bfred-it/object-fit-images/issues/53
			nativeSetAttribute.call(el, 'data-ofi-src', el.src)
			if (el.srcset) {
				nativeSetAttribute.call(el, 'data-ofi-srcset', el.srcset)
			}

			setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height)

			// remove srcset because it overrides src
			if (el.srcset) {
				el.srcset = ''
			}
			try {
				keepSrcUsable(el)
			} catch (err) {
				if (window.console) {
					console.warn('https://bit.ly/ofi-old-browser')
				}
			}
		}

		polyfillCurrentSrc(ofi.img)

		el.style.backgroundImage = 'url("' + (ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"') + '")'
		el.style.backgroundPosition = style['object-position'] || 'center'
		el.style.backgroundRepeat = 'no-repeat'
		el.style.backgroundOrigin = 'content-box'

		if (/scale-down/.test(style['object-fit'])) {
			onImageReady(ofi.img, function () {
				if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
					el.style.backgroundSize = 'contain'
				} else {
					el.style.backgroundSize = 'auto'
				}
			})
		} else {
			el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%')
		}

		onImageReady(ofi.img, function (img) {
			setPlaceholder(el, img.naturalWidth, img.naturalHeight)
		})
	}

	function keepSrcUsable(el) {
		var descriptors = {
			get: function get(prop) {
				return el[OFI].img[prop ? prop : 'src']
			},
			set: function set(value, prop) {
				el[OFI].img[prop ? prop : 'src'] = value
				nativeSetAttribute.call(el, 'data-ofi-' + prop, value) // preserve for any future cloneNode
				fixOne(el)
				return value
			},
		}
		Object.defineProperty(el, 'src', descriptors)
		Object.defineProperty(el, 'currentSrc', {
			get: function () {
				return descriptors.get('currentSrc')
			},
		})
		Object.defineProperty(el, 'srcset', {
			get: function () {
				return descriptors.get('srcset')
			},
			set: function (ss) {
				return descriptors.set(ss, 'srcset')
			},
		})
	}

	function hijackAttributes() {
		function getOfiImageMaybe(el, name) {
			return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el
		}
		if (!supportsObjectPosition) {
			HTMLImageElement.prototype.getAttribute = function (name) {
				return nativeGetAttribute.call(getOfiImageMaybe(this, name), name)
			}

			HTMLImageElement.prototype.setAttribute = function (name, value) {
				return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value))
			}
		}
	}

	function fix(imgs, opts) {
		var startAutoMode = !autoModeEnabled && !imgs
		opts = opts || {}
		imgs = imgs || 'img'

		if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
			return false
		}

		// use imgs as a selector or just select all images
		if (imgs === 'img') {
			imgs = document.getElementsByTagName('img')
		} else if (typeof imgs === 'string') {
			imgs = document.querySelectorAll(imgs)
		} else if (!('length' in imgs)) {
			imgs = [imgs]
		}

		// apply fix to all
		for (var i = 0; i < imgs.length; i++) {
			imgs[i][OFI] = imgs[i][OFI] || {
				skipTest: opts.skipTest,
			}
			fixOne(imgs[i])
		}

		if (startAutoMode) {
			document.body.addEventListener(
				'load',
				function (e) {
					if (e.target.tagName === 'IMG') {
						fix(e.target, {
							skipTest: opts.skipTest,
						})
					}
				},
				true,
			)
			autoModeEnabled = true
			imgs = 'img' // reset to a generic selector for watchMQ
		}

		// if requested, watch media queries for object-fit change
		if (opts.watchMQ) {
			window.addEventListener(
				'resize',
				fix.bind(null, imgs, {
					skipTest: opts.skipTest,
				}),
			)
		}
	}

	fix.supportsObjectFit = supportsObjectFit
	fix.supportsObjectPosition = supportsObjectPosition

	hijackAttributes()

	return fix
})()

// array includes polyfill
if (!Array.prototype.includes) {
	Object.defineProperty(Array.prototype, 'includes', {
		value: function (searchElement, fromIndex) {
			if (this == null) {
				throw new TypeError('"this" is null or not defined')
			}

			var o = Object(this)
			var len = o.length >>> 0

			if (len === 0) {
				return false
			}

			var n = fromIndex | 0
			var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0)

			while (k < len) {
				if (o[k] === searchElement) {
					return true
				}
				k++
			}

			return false
		},
	})
}
